import { render, staticRenderFns } from "./MessageAdvancedSearchAulaSearch.vue?vue&type=template&id=79ab8cf9&scoped=true&"
import script from "./MessageAdvancedSearchAulaSearch.vue?vue&type=script&lang=js&"
export * from "./MessageAdvancedSearchAulaSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ab8cf9",
  null
  
)

export default component.exports